export function getHomepageUrl(suffix: string) {
  if (typeof window === 'undefined') return suffix;

  const url = new URL(window.location.origin);

  // Strip known app subdomain prefixes (e.g. "studio.getcartwheel.com" → "getcartwheel.com")
  const subdomainsToStrip = ['studio', 'app', 'labeler'];
  for (const sub of subdomainsToStrip) {
    if (url.hostname.startsWith(`${sub}.`)) {
      url.hostname = url.hostname.slice(sub.length + 1);
      break;
    }
    // Non-prod variant with hyphen (e.g. "studio-staging.getcartwheel.com" → "staging.getcartwheel.com")
    if (url.hostname.startsWith(`${sub}-`)) {
      url.hostname = url.hostname.slice(sub.length + 1);
      break;
    }
  }

  // Remap known app ports to homepage port
  const homepagePort: Record<string, string> = {
    '3001': '3000',
    '3010': '3000',
  };
  if (url.port in homepagePort) {
    url.port = homepagePort[url.port];
  }

  return `${url.origin}${suffix}`;
}
